import { Box, Icon, Typography } from '@material-ui/core'
import { useStyles } from './styles'
import { useFidelityTabs } from './useFidelityTabs'

export const FidelityTabs = () => {
  const classes = useStyles()
  const { filterCollection, getActiveTab, handleChangeTab } = useFidelityTabs()
  return (
    <Box className={classes.container}>
      {filterCollection.map(({ key, name, icon, value }) => {
        return (
          <Box
            key={key}
            className={classes.tabContainer}
            data-active={getActiveTab({ value })}
            onClick={() => handleChangeTab(value)}
          >
            <Icon>{icon}</Icon>
            <Typography>{name}</Typography>
          </Box>
        )
      })}
    </Box>
  )
}
